import { render, staticRenderFns } from "./QuickLabelling.vue?vue&type=template&id=16d7c6a8&scoped=true&"
import script from "./QuickLabelling.vue?vue&type=script&lang=ts&"
export * from "./QuickLabelling.vue?vue&type=script&lang=ts&"
import style0 from "./QuickLabelling.vue?vue&type=style&index=0&id=16d7c6a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7c6a8",
  null
  
)

export default component.exports